const TONE_CLASSES: Record<string, string> = {
  neutral: "bg-ink-100 text-ink-700",
  pending: "bg-amber-100 text-amber-800",
  good: "bg-emerald-100 text-emerald-800",
  warn: "bg-orange-100 text-orange-800",
  bad: "bg-red-100 text-red-800",
};

const BROADCAST_LABELS: Record<string, { label: string; tone: string }> = {
  queued: { label: "En cola", tone: "pending" },
  sending: { label: "Enviando", tone: "pending" },
  completed: { label: "Completado", tone: "good" },
  cancelled: { label: "Detenido", tone: "warn" },
  failed: { label: "Falló", tone: "bad" },
};

const RECIPIENT_LABELS: Record<string, { label: string; tone: string }> = {
  pending: { label: "Pendiente", tone: "neutral" },
  sending: { label: "Enviando", tone: "pending" },
  sent: { label: "Enviado", tone: "pending" },
  delivered: { label: "Entregado", tone: "good" },
  read: { label: "Leído", tone: "good" },
  failed: { label: "Falló", tone: "bad" },
  excluded: { label: "Excluido", tone: "neutral" },
  // The honest label for a row a crash left mid-flight. We never re-send it —
  // a duplicate marketing message is a double charge and a report waiting to
  // happen — so the screen says we do not know rather than guessing.
  unknown: { label: "Sin confirmar", tone: "warn" },
};

export function BroadcastStatusBadge({
  status,
  kind = "broadcast",
}: {
  status: string;
  kind?: "broadcast" | "recipient";
}): React.JSX.Element {
  const map = kind === "recipient" ? RECIPIENT_LABELS : BROADCAST_LABELS;
  const entry = map[status] ?? { label: status, tone: "neutral" };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        TONE_CLASSES[entry.tone] ?? TONE_CLASSES.neutral
      }`}
    >
      {entry.label}
    </span>
  );
}
